const RELATIVE_URL_BASE = 'https://relative-url.invalid'

export function addFavoriteParam(relativeUrl: string, productId: number): string {
  const { pathname, search, hash } = new URL(relativeUrl, RELATIVE_URL_BASE)
  const separator = search ? '&' : '?'

  return `${pathname}${search}${separator}addFavorite=${productId}${hash}`
}
